export const state = {
  personalMessage: window.localStorage.getItem('messageStatus')
    ? window.localStorage.getItem('messageStatus')
    : null,
  insomniaDetails: window.localStorage.getItem('insomniaDetails')
    ? window.localStorage.getItem('insomniaDetails')
    : null,
}

export const getters = {
  getPersonalMessage: (state) => {
    return state.personalMessage ? state.personalMessage : null
  },
  getInsomniaDetails: (state) => {
    return state.insomniaDetails ? state.insomniaDetails : null
  },
}

export const mutations = {
  SET_PERSONAL_MESSAGE(state, newValue) {
    state.personalMessage = newValue
  },
  SET_INSOMNIA_DETAILS(state, newValue) {
    state.insomniaDetails = newValue
  },
}

export const actions = {
  setPersonalMessage({ commit, state }, payload) {
    if (payload) {
      window.localStorage.setItem('messageStatus', payload)
      commit('SET_PERSONAL_MESSAGE', payload)
      return payload
    }
    return null
  },
  setInsomniaDetails({ commit, state }, payload) {
    if (payload) {
      window.localStorage.setItem('insomniaDetails', payload)
      commit('SET_INSOMNIA_DETAILS', payload)
      return payload
    }
    return null
  },
}
